import { inject, Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import { map } from "rxjs";
import {
  initializeApp,
  initializeWithNoToken,
  initializeWithToken,
  setAuthLoading
} from "../actions/auth";
import { AuthService } from "../../../../core/auth/service/auth.service";
import dayjs from "dayjs";

@Injectable()
export class AppEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);

  initialize$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(initializeApp),
      map(() => this.createInitializationActionFromStoredToken())
    );
  });

  private createInitializationActionFromStoredToken() {
    // Read and decode the persisted token first so that startup can route users to the correct authenticated or guest flow.
    const token = this.authService.getStoredAuthToken();
    const decodedValue = this.authService.decodeAuthToken(token);

    if (!token || !decodedValue?.roleUserId) {
      return initializeWithNoToken();
    }

    if (!decodedValue.exp || !dayjs().isBefore(dayjs.unix(decodedValue.exp))) {
      return setAuthLoading({ loading: true });
    }

    const sessionId = parseInt(decodedValue.sessionId, 10);

    return initializeWithToken({
      token,
      sessionId,
      accountType: decodedValue.role,
      expiresAt: dayjs.unix(decodedValue.exp).toISOString(),
      userProfile: {
        id: sessionId,
        emailAddress: decodedValue.email,
        firstName: decodedValue.given_name,
        lastName: decodedValue.family_name,
        profilePictureFileName: null,
        mobileNumber: "",
        status: "Active",
      },
    });
  }
}
